import React, { type MutableRefObject } from 'react';

import { Button } from '../../../../components';
import SharedProponentFormSection, {
  type SharedProponentFormSectionLabels,
} from '../../../../components/pagesComponents/vidaPageComponents/SharedProponentFormSection';
import type { ProponentFormValues } from '../../../../types/vida/cadastralMaintenance/proponentFormTypes';
import type { PersonFormSection, PersonFormSectionControl } from '../../../../types/vida/cadastralMaintenance/personFormTypes';

type ProponentFormSectionProps = {
  onValidityChange?: (isValid: boolean) => void;
  onValuesChange?: (values: ProponentFormValues) => void;
  initialValues?: ProponentFormValues;
  readOnly?: boolean;
  showBeneficiariosButton?: boolean;
  isBeneficiariosActive?: boolean;
  onBeneficiariosClick?: () => void;
  onExitBeneficiarios?: () => void;
  sectionControlRef?: MutableRefObject<PersonFormSectionControl | null>;
  onActiveSectionChange?: (section: PersonFormSection) => void;
};

const ProponentFormSection: React.FC<ProponentFormSectionProps> = ({
  onValidityChange,
  onValuesChange,
  initialValues,
  readOnly = false,
  showBeneficiariosButton = false,
  isBeneficiariosActive = false,
  onBeneficiariosClick,
  onExitBeneficiarios,
  sectionControlRef,
  onActiveSectionChange,
}) => {
  const labels: SharedProponentFormSectionLabels = {
    personDataButton: 'Dados do Proponente',
    personDataAriaLabel: 'Exibir dados do proponente',
    personDataTitle: 'Dados do Proponente',
    personAddressButton: 'Endereço do Proponente',
    personAddressAriaLabel: 'Exibir endereço do proponente',
    personAddressTitle: 'Endereço do Proponente',
    insuranceInfoButton: 'Dados Empresariais',
    insuranceInfoAriaLabel: 'Exibir dados empresariais',
    insuranceInfoTitle: 'Dados Empresariais',
  };

  const beneficiariosButton = showBeneficiariosButton ? (
    <Button
      type="button"
      color="primary"
      fill={isBeneficiariosActive ? 'solid' : 'outline'}
      onClick={onBeneficiariosClick}
      aria-label="Exibir beneficiários do proponente"
      aria-pressed={isBeneficiariosActive}
    >
      Beneficiários
    </Button>
  ) : null;

  return (
    <SharedProponentFormSection
      labels={labels}
      onValidityChange={onValidityChange}
      onValuesChange={onValuesChange}
      initialValues={initialValues}
      readOnly={readOnly}
      extraNavButtons={beneficiariosButton}
      hideFormSections={isBeneficiariosActive}
      onSectionNavChange={() => onExitBeneficiarios?.()}
      sectionControlRef={sectionControlRef}
      onActiveSectionChange={onActiveSectionChange}
    />
  );
};

export default ProponentFormSection;
